import request from '@/utils/request'

/**
 * 商务洽谈 / 留言咨询留资（与短剧端 App.vue 提交字段一致）
 * POST /manage/leadinquiries
 */
export function createLeadInquiry (payload) {
  return request({
    url: '/manage/leadinquiries',
    method: 'post',
    data: payload
  })
}
